module.exports = __webpack_public_path__ + "static/5-5fe4e807917176a8a96cf96c20f71749.mp4";